(() => {
  const selector = '[data-babalu-mobile-editorial="true"]';
  const featuredClass = 'babalu-mobile-editorial-featured';
  const mobileQuery = window.matchMedia('(max-width: 767px)');

  const asPositiveInteger = (value, fallback) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  };

  const applyEditorialGrid = (grid) => {
    const customPattern = {
      beforeFirstFeature: asPositiveInteger(grid.dataset.babaluEditorialBeforeFirst, 6),
      betweenFeatures: asPositiveInteger(grid.dataset.babaluEditorialBetween, 4),
      consecutiveFeatures: asPositiveInteger(grid.dataset.babaluEditorialConsecutive, 2),
    };
    const presets = {
      standard: { beforeFirstFeature: 6, betweenFeatures: 4, consecutiveFeatures: 2 },
      cadence: { beforeFirstFeature: 5, betweenFeatures: 5, consecutiveFeatures: 2 },
      showcase: { beforeFirstFeature: 4, betweenFeatures: 3, consecutiveFeatures: 2 },
    };
    const pattern = presets[grid.dataset.babaluEditorialPreset] || customPattern;
    const { beforeFirstFeature, betweenFeatures, consecutiveFeatures } = pattern;
    const cycleLength = beforeFirstFeature + 1 + betweenFeatures + consecutiveFeatures;
    const cards = Array.from(grid.querySelectorAll(':scope > hdt-card-product'));

    cards.forEach((card, index) => {
      const position = (index % cycleLength) + 1;
      const isFeatured = mobileQuery.matches && (
        position === beforeFirstFeature + 1 ||
        position > beforeFirstFeature + 1 + betweenFeatures
      );
      card.classList.toggle(featuredClass, isFeatured);
    });
  };

  const applyAll = () => document.querySelectorAll(selector).forEach(applyEditorialGrid);
  const observer = new MutationObserver(applyAll);

  document.addEventListener('DOMContentLoaded', () => {
    applyAll();
    observer.observe(document.body, { childList: true, subtree: true });
  });
  mobileQuery.addEventListener('change', applyAll);
  document.addEventListener('shopify:section:load', applyAll);
})();
